/** @see index.html inline script — keep logic in sync for first-paint theme */

export const THEME_STORAGE_KEY = 'fcp_theme';
export const DEFAULT_THEME = 'system';
const VALID_THEMES = new Set(['light', 'dark', 'system', 'auto']);

export function normalizeTheme(value) {
  if (!VALID_THEMES.has(value)) return DEFAULT_THEME;
  return value === 'auto' ? 'system' : value;
}

export function getSystemDark() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Resolved dark mode for a stored preference (matches index.html blocking script). */
export function resolveIsDark(theme) {
  const normalized = normalizeTheme(theme);
  return normalized === 'dark' || (normalized === 'system' && getSystemDark());
}

export function applyThemeToDOM(theme) {
  if (typeof document === 'undefined') return;
  const dark = resolveIsDark(theme);
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  if (dark) {
    document.documentElement.classList.add('dark');
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    document.documentElement.classList.remove('dark');
    document.documentElement.setAttribute('data-theme', 'light');
  }
}

export function readStoredTheme() {
  if (typeof window === 'undefined') return DEFAULT_THEME;
  return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
}
